
import { defineComponent, PropType } from 'vue'
import { RecentStat, TrendDirection } from '~/types/types'
import { shortenLargeNumber } from '~/utils/string'

/**
 * Component to show recent and current values of a report.
 */
export default defineComponent({
  name: 'RecentStats',
  data() {
    return {
      TrendDirection
    }
  },
  props: {
    stats: {
      type: Array as PropType<Array<RecentStat>>,
      required: true
    },
    currentVal: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    shortenLargeNumber,
    /**
     * Parse trend direction enum values to ticker component compatible values.
     *
     * @param trendDirection TrendDirection
     * @returns string
     */
    direction(trendDirection: TrendDirection): string {
      return trendDirection === TrendDirection.Up ? 'up' : 'down'
    },

    /**
     * Returns string to render inside ticker
     *
     * @param trendValue number
     * @param statValue number
     *
     * @returns string
     */
    smartTrendValue(trendValue: number, statValue: number): string {
      // statValue = 0 means that the change is infinity, this case is handled here
      // The ticker does not render for statValue is zero, this change is just for extra defense
      if (statValue === 0) return ''

      if (trendValue < 120) return `${trendValue}%`

      const smartValue = (trendValue / 100).toFixed(1)

      return `${smartValue}x`
    }
  }
})
